var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkBus1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_322_2838)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 9.5,
    stroke: "#F68888"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2012 15.949H9.48212L10.9706 14.5024H12.6897L11.2012 15.949Z",
    fill: "#3C373A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8197 15.949H18.5388L17.0503 14.5024H15.3312L16.8197 15.949Z",
    fill: "#3C373A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.82269V12.3007C19 13.2021 18.2662 13.9569 17.3438 13.9569H10.6562C9.75472 13.9569 9 13.2231 9 12.3007V5.82269C9 4.92122 9.73375 4.1665 10.6562 4.1665H17.3438C18.2662 4.18747 19 4.92122 19 5.82269ZM11.8721 12.2378C11.8721 11.8395 11.5367 11.504 11.1384 11.504C10.74 11.504 10.4046 11.8395 10.4046 12.2378C10.4046 12.6361 10.7191 12.9715 11.1384 12.9715C11.5576 12.9715 11.8721 12.6571 11.8721 12.2378ZM17.5954 12.2378C17.5954 11.8395 17.26 11.504 16.8616 11.504C16.4633 11.504 16.1279 11.8395 16.1279 12.2378C16.1279 12.6361 16.4633 12.9715 16.8616 12.9715C17.26 12.9715 17.5954 12.6571 17.5954 12.2378ZM17.9727 6.2839C17.9727 5.92751 17.6792 5.63401 17.3229 5.63401H10.6981C10.3417 5.63401 10.0482 5.92751 10.0482 6.2839V8.35938C10.0482 8.71577 10.3417 9.00927 10.6981 9.00927H17.3229C17.6792 9.00927 17.9727 8.71577 17.9727 8.35938V6.2839Z",
    fill: "#3C373A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_322_2838",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_322_2838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_322_2838",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkBus1);
export default __webpack_public_path__ + "static/media/mark-bus-1.0f498444320b76829343e57c447e3e39.svg";
export { ForwardRef as ReactComponent };